import React, { createElement, useState } from 'react'
import { Table } from 'antd'
import type { TableProps } from 'antd'
import { ComponentController } from './components/component_controller'

type TableElementProps = {
  key: React.Key
  body: string
}

const columns = [
  {
    title: 'Common Status Questions',
    dataIndex: 'body',
    render: (text: string) => createElement('span', {}, text),
  },
]

const TableElement = ({
  columns,
  dataSource,
  onRowSelectionChange,
  selectedRowKeys: initialSelectedRowKeys,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState(initialSelectedRowKeys)

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[]) => {
      setSelectedRowKeys(selectedRowKeys)
      onRowSelectionChange(selectedRowKeys)
    },
    selectedRowKeys: selectedRowKeys,
    getCheckboxProps: (record: TableElementProps) => ({
      name: record.body,
      'aria-label': record.body,
    }),
  }

  return createElement(Table, {
    rowSelection: rowSelection,
    columns: columns,
    dataSource: dataSource,
    pagination: false,
  })
}

export class CommonStatusQuestionsController extends ComponentController {
  static targets = ['input', 'component']

  declare inputTarget: HTMLInputElement
  declare componentTarget: HTMLInputElement

  get component() {
    return TableElement
  }

  get initialProps(): any {
    const props = this.propsFromData
    const selectedRowKeys = this.inputTarget.value.split(',')
    return {
      columns: columns,
      onRowSelectionChange: this.onRowSelectionChange,
      selectedRowKeys: selectedRowKeys,
      ...props,
    }
  }
  get rootElement() {
    return this.componentTarget
  }

  onRowSelectionChange = (selectedRowKeys: React.Key[]) => {
    this.inputTarget.value = selectedRowKeys.join(',')
  }
}
